<div class="container">
  <h2 class="mb-4">Clients List</h2>

  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Company Name</th>
          <th>Address</th>
          <th>Region</th>
          <th>Website</th>
          <th>Actions</th>
        </tr>

        <!-- Filter Row -->
        <tr>
          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Company"
              [(ngModel)]="filter.companyName"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Address"
              [(ngModel)]="filter.address"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Region"
              [(ngModel)]="filter.region"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <input
              type="text"
              class="form-control"
              placeholder="Search Website"
              [(ngModel)]="filter.website"
              (input)="applyFilters()"
            />
          </th>

          <th>
            <button
              (click)="resetFilters()"
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let client of filteredClientsList">
          <td>{{ client.companyName }}</td>
          <td>{{ client.address }}</td>
          <td>{{ client.region }}</td>
          <td>{{ client.website }}</td>

          <td>
            <button
              class="btn btn-secondary btn-sm me-2"
              (click)="updateClient(client)"
              [disabled]="!hasPermission('ClientsAddNewClientPermission')"
            >
              <i class="fa fa-edit" aria-hidden="true"></i>
            </button>

            <button
              class="btn btn-danger btn-sm"
              (click)="deleteClient(client)"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </td>
        </tr>

        <tr *ngIf="filteredClientsList.length === 0">
          <td colspan="5" class="text-center">
            No clients found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>